export const tooltipLabelsDefault = {
  enabled: 'Show your current location',
  disabled: 'Location unavailable',
}

export const ariaLabel = 'geolocation'
